export const CLEAR_LOGS = 'LANDLORD_LOGS::CLEAR_LOGS';
export const SAVE_LOGS = 'LANDLORD_LOGS::SAVE_LOGS';
